/**
 * Room Theme Configurations — The Enlightened Museum
 * Light, warm, welcoming academic palette per room.
 * Adding a new room = adding an entry here + adding to ROOM_ORDER.
 */

export const ROOM_THEMES = {
  'philosophy-hall': {
    id: 'philosophy-hall',
    name: 'Philosophy Hall',
    tagline: 'The Unexamined Life Is Not Worth Living',
    description: 'The eternal forum where humanity\'s deepest questions are explored',
    accent: '#6D5A8C',
    accentLight: '#9F8CC2',
    accentBg: 'rgba(109,90,140,0.06)',
    surface: '#F3F0F9',
    gradient: 'linear-gradient(135deg, #F8F6FC 0%, #EEEAF5 100%)',
    portraitFrame: 'marble',
    bgImage: 'https://images.unsplash.com/photo-1767842882299-bf7c21993f45?w=1920&q=80',
    doorGradient: 'linear-gradient(180deg, #F3F0F9 0%, #E6E1F0 100%)',
    doorBorder: 'rgba(109,90,140,0.25)',
  },
  'innovation-lab': {
    id: 'innovation-lab',
    name: 'Innovation Lab',
    tagline: 'Think Different. Build Tomorrow.',
    description: 'Where visionaries and disruptors gather to reshape the future',
    accent: '#008B8B',
    accentLight: '#20B2AA',
    accentBg: 'rgba(0,139,139,0.05)',
    surface: '#F0F9FA',
    gradient: 'linear-gradient(135deg, #F5FBFB 0%, #E5F3F5 100%)',
    portraitFrame: 'holographic',
    bgImage: 'https://images.unsplash.com/photo-1665690399850-036127c5da17?w=1920&q=80',
    doorGradient: 'linear-gradient(180deg, #F0F9FA 0%, #E0F2F5 100%)',
    doorBorder: 'rgba(0,139,139,0.25)',
  },
  'creative-studio': {
    id: 'creative-studio',
    name: 'Creative Studio',
    tagline: 'Every Artist Was First An Amateur',
    description: 'Masters of art, music, and creative expression across the ages',
    accent: '#CD853F',
    accentLight: '#DEB887',
    accentBg: 'rgba(205,133,63,0.06)',
    surface: '#FAF3EB',
    gradient: 'linear-gradient(135deg, #FBF7F1 0%, #F0E6DA 100%)',
    portraitFrame: 'gilded',
    bgImage: 'https://images.pexels.com/photos/6045331/pexels-photo-6045331.jpeg?auto=compress&cs=tinysrgb&w=1920',
    doorGradient: 'linear-gradient(180deg, #FAF3EB 0%, #F0E6DA 100%)',
    doorBorder: 'rgba(205,133,63,0.25)',
  },
  'british-greats': {
    id: 'british-greats',
    name: 'British Greats',
    tagline: 'We Shall Never Surrender',
    description: 'Icons who defined the spirit and legacy of the British Isles',
    accent: '#8B2252',
    accentLight: '#C2476B',
    accentBg: 'rgba(139,34,82,0.06)',
    surface: '#F9F0F3',
    gradient: 'linear-gradient(135deg, #FBF5F7 0%, #F0E4EA 100%)',
    portraitFrame: 'gilded',
    bgImage: 'https://images.unsplash.com/photo-1543949806-2c9935e6aa78?w=1920&q=80',
    doorGradient: 'linear-gradient(180deg, #F9F0F3 0%, #F0E4EA 100%)',
    doorBorder: 'rgba(139,34,82,0.25)',
  },
  'science-academy': {
    id: 'science-academy',
    name: 'Science Academy',
    tagline: 'Imagination Is More Important Than Knowledge',
    description: 'Where the laws of the universe are decoded and debated',
    accent: '#2E6B8A',
    accentLight: '#4A96B8',
    accentBg: 'rgba(46,107,138,0.05)',
    surface: '#EFF5F8',
    gradient: 'linear-gradient(135deg, #F4F8FB 0%, #E4EEF4 100%)',
    portraitFrame: 'holographic',
    bgImage: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=1920&q=80',
    doorGradient: 'linear-gradient(180deg, #EFF5F8 0%, #E0ECF2 100%)',
    doorBorder: 'rgba(46,107,138,0.25)',
  },
  'world-shapers': {
    id: 'world-shapers',
    name: 'World Shapers',
    tagline: 'Be The Change You Wish To See',
    description: 'Leaders whose courage transformed nations and inspired generations',
    accent: '#2E7D32',
    accentLight: '#4CAF50',
    accentBg: 'rgba(46,125,50,0.05)',
    surface: '#F0F6F0',
    gradient: 'linear-gradient(135deg, #F5F9F5 0%, #E6F0E6 100%)',
    portraitFrame: 'gilded',
    bgImage: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=1920&q=80',
    doorGradient: 'linear-gradient(180deg, #F0F6F0 0%, #E2EDE2 100%)',
    doorBorder: 'rgba(46,125,50,0.25)',
  },
};

// All 6 rooms in display order
export const ROOM_ORDER = [
  'philosophy-hall',
  'innovation-lab',
  'creative-studio',
  'british-greats',
  'science-academy',
  'world-shapers',
];

export const getRoomTheme = (roomId) => ROOM_THEMES[roomId] || null;
